import React, { Fragment, useEffect, useContext } from "react";
import moment from "moment";
import { fetchOrderByUser } from "./Action";
import Layout, { DashboardUserContext } from "./Layout";
import { FaWhatsapp } from "react-icons/fa";

const apiURL = process.env.REACT_APP_API_URL;

const TableHeader = () => (
  <thead className="bg-gray-100">
    <tr>
      <th className="px-4 py-2 border text-left">Produtos</th>
      <th className="px-4 py-2 border text-center">Status</th>
      <th className="px-4 py-2 border text-center">Total</th>
      <th className="px-4 py-2 border text-center">Rastreamento</th>
      <th className="px-4 py-2 border text-center">Data</th>
    </tr>
  </thead>
);

const TableBody = ({ order }) => {
  const statusColors = {
    "Não processado": "text-red-600",
    "Em Análise": "text-yellow-700",
    "Enviado": "text-yellow-700",
    "Entregue": "text-green-600",
    "Cancelado": "text-red-600",
  };

  return (
    <tr className="border-b hover:bg-gray-50">
      <td className="p-2 space-y-2">
        {order.allProduct?.length > 0 ? (
          order.allProduct.map((product, index) => (
            <div key={product._id || index} className="flex items-center space-x-2">
              <img
                className="w-8 h-8 rounded object-cover border"
                src={`${apiURL}/uploads/products/${product.pImages?.[0]}`}
                alt={`Imagem de ${product.pName}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/default-product.png";
                }}
              />
              <span>{product.pName}</span>
              <span className="text-gray-500">{product.quantity}x</span>
            </div>
          ))
        ) : (
          <span className="text-gray-500">Nenhum produto.</span>
        )}
      </td>
      <td className="text-center p-2">
        <span className={`text-xs font-semibold ${statusColors[order.status] || "text-gray-600"}`}>
          {order.status}
        </span>
      </td>
      <td className="text-center p-2">
        R$ {order.amount?.toFixed(2).replace(".", ",") || "0,00"}
      </td>
      <td className="text-center p-2">{order.transactionId || "N/A"}</td>
      <td className="text-center p-2">
        {order.updatedAt ? moment(order.updatedAt).format("DD/MM/YYYY") : "N/A"}
      </td>
    </tr>
  );
};

const OrdersComponent = () => {
  const { data, dispatch } = useContext(DashboardUserContext);
  const orders = data.OrderByUser || [];

  useEffect(() => {
    fetchOrderByUser(dispatch);
  }, [dispatch]);

  if (data.loading) {
    return (
      <div className="flex items-center justify-center w-full py-24">
        <svg className="w-12 h-12 animate-spin text-primary" fill="none" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          />
        </svg>
      </div>
    );
  }

  return (
    <Fragment>
      <div className="flex flex-col w-full md:w-9/12 my-4 md:px-8">
        <div className="shadow-lg border rounded-xl overflow-hidden">
          <div className="py-4 px-6 text-xl font-bold text-flitz-primary border-l-4 border-flitz-accent bg-gray-50">
            Meus Pedidos — Flitz
          </div>
          <div className="overflow-auto bg-white p-4">
            <table className="table-auto border w-full my-2 text-sm">
              <TableHeader />
              <tbody>
                {orders.length > 0 ? (
                  orders.map((order) => <TableBody key={order._id} order={order} />)
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-gray-500 py-6">
                      Nenhum pedido encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="text-sm text-gray-600 mt-2">
              Total de pedidos: {orders.length}.
            </div>

            <div className="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded">
              <h2 className="text-lg font-semibold text-yellow-700">Informações sobre entrega</h2>
              <p className="mt-2 text-gray-700">
                Os pedidos são entregues em até <strong>7 a 10 dias úteis</strong> após a confirmação do pagamento.
              </p>
              <p className="mt-2 text-gray-700">
                Precisa com urgência? Fale com nosso time de atendimento via WhatsApp ou e-mail.
              </p>
            </div>

            <div className="mt-6 text-center">
              <p className="text-gray-600">Precisa de ajuda com seu pedido?</p>
              <a href="mailto:contato@flitz.com.br" className="text-flitz-primary underline">
                contato@flitz.com.br
              </a>
              <div className="mt-4">
                <a
                  href="https://wa.me/559591273913?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20meu%20pedido%20na%20Flitz."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-4 py-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                >
                  <FaWhatsapp className="mr-2" />
                  Falar com a Flitz
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const UserOrders = () => {
  return <Layout children={<OrdersComponent />} />;
};

export default UserOrders;